import auth from './slices/auth';

const rootReducer = {
  auth,
};

export default rootReducer;
